// extracted by mini-css-extract-plugin
export default {"radioList":"Health_radioList__2Smha","radioOption":"Health_radioOption__09s7x","buttonFooter":"Health_buttonFooter__46E4r","buttonFooterFixed":"Health_buttonFooterFixed__x+j-P"};